import store from "./index";
import axios from 'axios'

export default {
    state: {
        allPromocodes: null,
        totalCount: 0,
        loading: false,
        queryObject: {
            searchTxt: '',
            ordering: {},
            filters: {},
            limit: 20
        },
        selectedPromocode: null,
    },
    getters: {
        getAllPromocodes(state) {
            return state.allPromocodes
        },
        getPromocodesLoading(state) {
            return state.loading
        },
        getPromocodesTotalCount(state) {
            return state.totalCount
        },
        getSelectedPromocode(state) {
            return state.selectedPromocode
        },
    },
    mutations: {
        setAllPromocodes(state, promocodes) {
            state.allPromocodes = promocodes
        },
        setPromocodesLoading(state, loading) {
            state.loading = !!loading
        },
        setPromocodesTotalCount(state, totalCount) {
            state.totalCount = totalCount
        },
        setSelectedPromocode(state, promocode) {
            state.selectedPromocode = promocode
        },
    },
    actions: {
        fetchPromocodes({commit, state}, queryOption) {
            state.queryObject = queryOption

            let orderingArray = Object.values(queryOption.ordering)
            let orderingString = orderingArray.join('&ordering=')
            let filterArray = Object.values(queryOption.filters)
            let filterString = filterArray.join('&')
            let url

            if (Object.keys(queryOption.ordering).length !== 0 && Object.keys(queryOption.filters).length !== 0) {
                url = `${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/promo/codes?limit=${queryOption.limit}&search=${queryOption.searchTxt}&ordering=${orderingString}&${filterString}`
            } else if (Object.keys(queryOption.ordering).length !== 0 && Object.keys(queryOption.filters).length === 0) {
                url = `${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/promo/codes?limit=${queryOption.limit}&search=${queryOption.searchTxt}&ordering=${orderingString}`
            } else if (Object.keys(queryOption.ordering).length === 0 && Object.keys(queryOption.filters).length !== 0) {
                url = `${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/promo/codes?limit=${queryOption.limit}&search=${queryOption.searchTxt}&${filterString}`
            } else {
                url = `${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/promo/codes?limit=${queryOption.limit}&search=${queryOption.searchTxt}`
            }

            if (queryOption.offset) url += queryOption.offset

            commit('setPromocodesLoading', true)
            return axios.get(url, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
                let _allPromocodes = state.allPromocodes
                if (queryOption.offset && _allPromocodes) {
                    response.data.forEach(elem => {
                        _allPromocodes.push(elem)
                    })
                    commit('setAllPromocodes', _allPromocodes)
                } else {
                    commit('setAllPromocodes', response.data)
                }
                commit('setPromocodesTotalCount', response.headers['total-count'])
                commit('setPromocodesLoading', false)
            }).catch(error => {
                console.log(error)
                commit('setPromocodesLoading', false)
                if (error.response && error.response.status == 401) {
                    this.dispatch('userLogout')
                } else {
                    commit('setErrorText', 'Ошибка соединения с сервером')
                }
            })
        },
        createPromocode({commit, state}, promocodeInfo) {
            return axios.post(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/promo/codes`, promocodeInfo, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
                this.dispatch('fetchPromocodes', state.queryObject)
                commit('setErrorText', 'Промокод успешно создан')
                return response.data
            }).catch(error => {
                if (error.response) {
                    commit('setErrorText', error.response.data || 'Ошибка создания промокода')
                }
                throw error
            })
        },
        updatePromocode({commit, state}, {promocodeId, promocodeInfo}) {
            return axios.patch(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/promo/codes/${promocodeId}`, promocodeInfo, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
                this.dispatch('fetchPromocodes', state.queryObject)
                commit('setErrorText', 'Промокод успешно обновлён')
                return response.data
            }).catch(error => {
                if (error.response) {
                    commit('setErrorText', error.response.data || 'Ошибка обновления промокода')
                }
                throw error
            })
        },
        deletePromocode({commit, state}, promocodeId) {
            return axios.delete(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/promo/codes/${promocodeId}`, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
                this.dispatch('fetchPromocodes', state.queryObject)
                commit('setErrorText', 'Промокод удалён')
            }).catch(error => console.log(error))
        },
        fetchPromocode({commit}, promocodeId) {
            return axios.get(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/promo/codes/${promocodeId}`, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
                commit('setSelectedPromocode', response.data)
                return response.data
            }).catch(error => {
                console.log(error)
                throw error
            })
        },
        autoPromocode() {
            return axios.post(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/promo/codes/auto`, {}, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
                return response.data.value
            }).catch(error => console.log(error))
        }
    }
}